import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import useGridOptionsMillSheetSearch from '../../../hooks/grid/gridOptions/useGridOptionsMillSheetSearch';
import commonColDef from '../../../data/grid/commonColDef';
import coldefMillSheetSearchDomestic from '../../../data/grid/coldefMillSheetSearchDomestic';
import coldefMillSheetSearchExport from '../../../data/grid/coldefMillSheetSearchExport';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { selectRows } from '../../../redux/slices/millSheetSearch';
import { BUSINESS_TYPE } from '../../../constants';
import type { ColDef, ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
import type { MillSheetType } from '../../../types/millSheetSearch';

const MillSheetGrid = (): React.ReactElement => {
  const dispatch = useDispatch();
  // const coldefMillSheetSearchDomain = useColdefMillSheetSearchDomestic(t);
  // const coldefMillSheetSearchExport = useColdefMillSheetSearchExport(t);

  const { isLoading, selectedBusinessType, searchResults } = useSelector((state: RootState) => state.millSheetSearch);
  const [gridApi, setGridApi] = useState<GridApi | undefined>(undefined);
  const [columnApi, setColumnApi] = useState<ColumnApi | undefined>(undefined);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>(coldefMillSheetSearchDomestic);
  const { gridOptions } = useGridOptionsMillSheetSearch();
  const customColDef: ColDef = {
    cellClass: 'excelStringColumn',
  };
  const defaultColDef: ColDef = Object.assign({}, commonColDef, customColDef);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  /**
   * Loading, NoRowsのグリッド表示
   */
  useEffect(() => {
    if (gridApi) {
      if (isLoading) {
        gridApi.showLoadingOverlay();
      } else {
        if (searchResults?.length) {
          gridApi.hideOverlay();
        } else {
          gridApi.showNoRowsOverlay();
        }
      }
    } else {
      // do nothing
    }
  }, [gridApi, isLoading, searchResults]);

  // 区分に応じてColDefを切り替える
  useEffect(() => {
    if (columnApi) {
      if (selectedBusinessType === BUSINESS_TYPE.DOMESTIC) {
        setColumnDefs(coldefMillSheetSearchDomestic);
      } else if (selectedBusinessType === BUSINESS_TYPE.EXPORT) {
        setColumnDefs(coldefMillSheetSearchExport);
      } else {
        setColumnDefs(coldefMillSheetSearchDomestic);
      }
    }
  }, [selectedBusinessType, columnApi]);

  // EVENT HANDLER
  // ================================================================================

  /**
   * グリッドが準備できたらAPIを利用できるようにする
   * @param params GridReadyEvent
   */
  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  };

  const onRowSelected = () => {
    if (gridApi !== undefined) {
      const selectedRows: MillSheetType[] = gridApi.getSelectedRows();
      dispatch(selectRows(selectedRows));
    } else {
      // do nothing
    }
  };

  // VIEW
  // ================================================================================

  return (
    <div className="ag-theme-balham" style={{ height: 'calc(100vh - 250px)' }}>
      <AgGridReact
        immutableData={true}
        gridOptions={gridOptions}
        defaultColDef={defaultColDef}
        columnDefs={columnDefs}
        rowData={searchResults}
        onGridReady={onGridReady}
        onRowSelected={onRowSelected}
      />
    </div>
  );
};

export default MillSheetGrid;
